import React, { useState } from 'react';
import { WorkoutHistory } from './WorkoutHistory';
import { WorkoutDetail } from './WorkoutDetail';

interface WorkoutHistoryManagerProps {
  onBack: () => void;
}

type HistoryState = 'list' | 'detail';

/**
 * WorkoutHistoryManager - Main component for workout history management
 * Handles navigation between workout list and detailed workout view
 * Requirements: 7.1, 7.2, 7.5
 */
export const WorkoutHistoryManager: React.FC<WorkoutHistoryManagerProps> = ({ onBack }) => {
  const [historyState, setHistoryState] = useState<HistoryState>('list');
  const [selectedWorkoutId, setSelectedWorkoutId] = useState<string | null>(null);

  const handleWorkoutSelect = (workoutId: string) => {
    setSelectedWorkoutId(workoutId);
    setHistoryState('detail');
  };

  const handleBackToList = () => {
    setSelectedWorkoutId(null);
    setHistoryState('list');
  };

  const handleWorkoutDelete = (workoutId: string) => {
    // Workout deleted, go back to list
    setSelectedWorkoutId(null);
    setHistoryState('list');
  };

  // Workout List State
  if (historyState === 'list') {
    return (
      <WorkoutHistory
        onWorkoutSelect={handleWorkoutSelect}
        onBack={onBack}
      />
    );
  }

  // Workout Detail State
  if (historyState === 'detail' && selectedWorkoutId) {
    return (
      <WorkoutDetail
        workoutId={selectedWorkoutId}
        onBack={handleBackToList}
        onDelete={handleWorkoutDelete}
      />
    );
  }

  // Fallback state
  return (
    <div className="workout-history-manager p-4 max-w-4xl mx-auto">
      <div className="text-center py-8">
        <div className="text-4xl mb-4">⚠️</div>
        <p className="text-gray-600 mb-4">Произошла ошибка</p>
        <button
          onClick={onBack}
          className="bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700"
        >
          Вернуться в главное меню
        </button>
      </div>
    </div>
  );
};

export default WorkoutHistoryManager;